<template>
  <div v-loading="loading" style="position:relative;">
    <div class="test_box" :class="{'test_box1':ShowTest}" v-if="btn_test">
      <el-button size="mini" type="primary" @click="ShowTest=!ShowTest">测 试</el-button>
      <div style="margin-top: 10px;" v-if="ShowTest">
        <!-- <el-time-picker
          size="mini"
          v-model="TestTimeS"
          value-format="HH:mm:ss"
          placeholder="判断晚休时间"
        /> -->
        <el-time-picker
          size="mini"
          v-model="TestTime"
          value-format="HH:mm:ss"
          placeholder="提交时间"
        />
        <!-- <el-button size="mini" type="primary" style="margin-left: 10px;" @click="setTime">设置时间</el-button> -->
      </div>
    </div>
    <el-row class="checkinge-query">
      <div class="query">
        <label>{{ day }}</label>
        <el-date-picker v-model="params.AttendanceDate" type="date" value-format="yyyy/MM/dd" placeholder="请选择日期" @change="getWeek(true)" style="width:140px" :clearable="false" />
      </div>
      <div class="query">
        <label>宿舍楼</label>
        <el-input v-model="params.DormitoryAddr" placeholder="请填写宿舍楼" clearable></el-input>
      </div>
      <div class="query">
        <label>宿舍号</label>
        <el-input v-model="params.DormitoryNumber" placeholder="请填写宿舍号" clearable></el-input>
      </div>
      <div class="query">
        <label>姓名</label>
        <el-input type="text" v-model="params.FullName" placeholder="请填写姓名" clearable></el-input>
      </div>
      <div class="query" v-if="!isMB">
        <el-button type="primary" @click="getNightSt">查询/刷新</el-button>
        <el-button type="success" v-if="mainData.length" @click="onExport" plain :loading="bnLoading">导出</el-button>
        <el-button type="primary" plain v-if="mainData.length" @click="showStatic">实时统计</el-button>
        <el-button type="danger" plain v-if="mainData.length" @click="showAttst">未考勤明细</el-button>
      </div>
      <template v-else>
        <div class="query2">
          <el-button type="primary" @click="getNightSt">查询/刷新</el-button>
        </div>
        <div class="query2">
          <el-button type="primary" plain v-if="mainData.length" @click="showStatic">实时统计</el-button>
        </div>
        <div class="query2">
          <el-button type="danger" plain v-if="mainData.length" @click="showAttst">未考勤明细</el-button>
        </div>
      </template>
    </el-row>
    <div v-if="mainData.length">
      <div class="border">
        <!-- ---------------------------------- -->
        <el-row class="tab-group" v-if="isMB">
          <div class="tab-tower-box">
            <div :class="{ 'tab-item': true, 'active': index == active }" class="tab-tower" v-for="(item,index) of mainData"
              :key="index" @click="addrChange2(item,index)">{{ item.Addr + '栋' }}</div>
          </div>
        </el-row>
        <el-row class="tab-group" v-else>
          <el-col :span="1" class="tab-item" style="width:4.1%;">宿舍楼</el-col>
          <el-col :span="1" :class="{ 'tab-item': true, 'active': index == active }" v-for="(item,index) of mainData"
            :key="index" @click.native="addrChange(index)">{{ item.Addr + '栋' }}</el-col>
        </el-row>
        <!-- ---------------------------------- -->
        <div class="floor-box" v-if="isMB">
          <div class="floor-item" :class="{ 'active': item.Floor==floorActive }" v-for="(item, index) of showData" @click="floorActive=item.Floor" :key="index">{{ item.Floor + '楼' }}</div>
        </div>
        <!-- ---------------------------------- -->
        <div class="table">
          <el-row v-for="(item, index) of showData" :key="index" class="table-item">
            <el-col :span="isMB?4:1" class="table-tower table-col" v-if="!isMB">
              <span>{{ item.Floor + '楼' }}</span>
            </el-col>
            <template v-for="(dorm,dIndex) of item.Dormitorys">
              <el-col :span="isMB?12:3" :offset="!isMB&&(dIndex>0&&dIndex%7==0)?1:0" class="table-dormList table-col" 
                :class="{'hideNames': dorm.showNames==false, 'deepColor': isMB&&dIndex%4>1, 'br': !isMB && (dIndex+1)%7==0 }" :key="dorm.DormitoryId" 
                :style="isMB&&(dIndex%2==1||(dIndex<item.Dormitorys.length-1&&!item.Dormitorys[dIndex+1].showNames))?'border-right:1px solid #666;':''" v-if="!isMB||item.Floor==floorActive">
                <!-- 宿舍号 -->
                <el-row class="table-dormList_header">
                  <div @click="dorm.showNames=!dorm.showNames||!isMB">
                    <el-col :span="isMB?5:6" style="text-align:left;">{{ dorm.Number }}</el-col>
                    <el-col :span="isMB?19:18" style="text-align:right;">{{ dorm.Classes }}</el-col>
                  </div>
                </el-row>
                <!-- 学生列表 -->
                <el-row class="student-list m-scroll" v-if="dorm.showNames">
                  <el-col class="student-item" :span="12" v-for="st of dorm.Students"
                    :key="st.studentsId">
                    <img :src="st.Face?face_purple:(st.AttendanceDtsId?face_blue:face)" v-if="st.atMode===0" class="face-icon">
                    <img :src="st.AttendanceDtsId?hand_blue:hand" v-else-if="st.atMode===1" class="hand-icon">
                    <!-- <el-popover
                      v-if="st.Status!=4&&st.Status!=5&&!st.Face&&canWrite"
                      placement="top"
                      width="215"
                      v-model="st.show">
                      <div style="margin-bottom: 10px;">修改考勤状态({{st.FullName}})</div>
                      <div style="text-align: right; margin: 0">
                        <el-button type="success" size="mini" @click="statusChange(st,1)">正常</el-button>
                        <el-button type="danger" size="mini" @click="statusChange(st,2)">异常</el-button>
                        <el-button type="warning" size="mini" @click="statusChange(st,3)">迟到</el-button>
                      </div>
                      <span class="stName" slot="reference" :class="{ 'normal': st.Status==1&&st.AttendanceDtsId==0&&!st.isChange, 'checkNormal': st.Status==1&&(st.AttendanceDtsId!=0||st.isChange), 
                      'absent': st.Status==2||st.noRecord, 'late': st.Status==3, 'free': st.Status==6, 'isChange': st.isChange, 'nobg': !st.isChange }"
                      >{{ st.FullName }}</span>
                    </el-popover> -->
                    <span class="stName" :class="{ 'normal': st.Status==1&&st.AttendanceDtsId==0&&!st.isChange, 'checkNormal': st.Status==1&&(st.AttendanceDtsId!=0||st.isChange), 
                      'absent': st.Status==2||st.noRecord, 'late': st.Status==3, 'free': st.Status==6, 'isChange': st.isChange, 'nobg': !st.isChange }"
                       v-if="st.Status!=4&&st.Status!=5&&!st.Face&&canWrite" @click="statusChange(st)">{{ st.FullName }}</span>
                    <span v-else class="stName" :class="{ 'normal': st.Status==1&&st.AttendanceDtsId==0&&!st.isChange, 'checkNormal': st.Status==1&&(st.AttendanceDtsId!=0||st.isChange), 
                    'absent': st.Status == 2 || st.noRecord, 'late': st.Status == 3, 'leave': st.Status == 4 || st.Status == 5, 'free': st.Status== 6, 'face': st.Face, 'nobg': !st.isChange }">
                      {{ st.FullName }}
                    </span>
                  </el-col>
                </el-row>
              </el-col>
            </template>
          </el-row>
        </div>
      </div>
      <div class="footer">
        <div class="footer-tip">
          <template v-if="!isMB">
            <span class="statusText">图标对应状态：</span>
            <span class="statusText nobold">
              <img :src="hand" class="face-icon">纯手动未考勤
            </span>
            <span class="statusText nobold">
              <img :src="hand_blue" class="face-icon">纯手动已考勤
            </span>
            <span class="statusText nobold">
              <img :src="face" class="face-icon">刷脸+抽查未考勤
            </span>
            <span class="statusText nobold">
              <img :src="face_blue" class="face-icon">刷脸+抽查已抽查
            </span>
            <span class="statusText nobold">
              <img :src="face_purple" class="face-icon">刷脸+抽查已刷脸
            </span>
          </template>
          <el-popover
            v-else
            placement="top"
            width="155">
              <div><img :src="hand" class="face-icon">纯手动未考勤</div>
              <div style="margin: 5px 0;"><img :src="hand_blue" class="face-icon">纯手动已考勤</div>
              <div><img :src="face" class="face-icon">刷脸+抽查未考勤</div>
              <div style="margin: 5px 0;"><img :src="face_blue" class="face-icon">刷脸+抽查已抽查</div>
              <div><img :src="face_purple" class="face-icon">刷脸+抽查已刷脸</div>
            <span class="statusText nobold" slot="reference">查看图标</span>
          </el-popover>
        </div>
        <div style="display:inline-block;">
          <span class="statusText" v-if="!isMB">颜色对应状态：</span>
          <span class="statusText checkNormal nobg">正常</span>
          <span class="statusText absent nobg">异常</span>
          <span class="statusText late nobg">迟到</span>
          <span class="statusText leave nobg">请假或医疗</span>
          <!-- <span class="statusText checkNormal nobg">医疗</span> -->
          <span class="statusText free nobg">无故缺勤</span>
          <!-- <span class="statusText face nobg">已刷脸</span> -->
          <el-button type="primary" @click="save" :disabled="loading" size="small" v-if="canWrite">提 交</el-button>
          <!-- <el-button type="success">导 出</el-button> -->
          <!-- <el-button type="primary" @click="callNames()">手动点名</el-button> -->
        </div>
      </div>
    </div>
    <div v-else class="border isNull">{{tipContent}}</div>
    <static-dialog ref="staticDialog"></static-dialog>
    <attst-dialog ref="attstDialog"></attst-dialog>
  </div>
</template>

<script>
import staticDialog from "./staticDialog";
import attstDialog from "./attstDialog";
export default {
  components: { staticDialog,attstDialog },
  props: {
    isIndex: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      canWrite: this.$permission.canWrite("/attendance/night"),
      api: require("@/api/at/attendance").default,
      atApi: require("@/api/attendance/studystay").default,
      hand: require("@/assets/hand.png"),
      face: require("@/assets/face.png"),
      hand_blue: require("@/assets/hand_blue.png"),
      face_blue: require("@/assets/face_blue.png"),
      face_purple: require("@/assets/face_purple.png"),
      loading: false,
      day: '',
      params: {
        AttendanceDate: this.$commonJs.getToday(),
        DormitoryNumber: "",
        DormitoryAddr: '',
        FullName: '',
      },
      mainData: [],
      showData: [],
      active: 0,
      floorActive: 0,
      towerTabs: [],
      towerList: [],
      subData: {},
      pickData: [],
      send: [],
      stData: [],
      atSetting: {},
      queried: {},
      TestTime: "",
      // TestTimeS: "",
      tipContent: "暂无晚休考勤数据",
      btn_test: false,
      ShowTest: false,
      bnLoading: false,
      isMB: this.$store.state.isMB
    }
  },
  beforeMount() {
    if (this.$route.query && this.$route.query.test == "1") {
      this.btn_test = true;
    } else {
      this.btn_test = false;
    }
    this.getWeek();
    if(!this.isIndex) this.getNightSt();
  },
  methods: {
    getNightSt() {
      this.subData = { Details: [], };
      this.pickData = [];
      this.showData = [];
      this.mainData = [];
      this.stData = [];
      this.send = [];
      this.active = 0;
      this.tipContent = "暂无晚休考勤数据";
      this.loading = true;
      this.queried = this.$commonJs.obj.removeNullKey(this.params);
      this.atApi.getListByDate(this.params.AttendanceDate).then(atRes => {
        if(atRes.Code==0) {
          if(atRes.Data.length) {
            var noStay = atRes.Data.find(x => x.StayMode != 2);
            if(!noStay) {
              this.tipContent = "当天设置了不留宿";
              this.loading = false;
              return;
            } 
            // else {
            //   var now = (new Date()).getTime();
            //   var time = false;
            //   if(this.TestTime) now = (new Date(this.params.AttendanceDate + " " + this.TestTime)).getTime();
            //   var arr = [new Date(atRes.Data[0].NightStartDateTime),new Date(atRes.Data[1].NightStartDateTime),new Date(atRes.Data[2].NightStartDateTime)];
            //   arr.forEach(e => {
            //     if(now >= (new Date(e)).getTime()) {
            //       time = true;
            //       return;
            //     }
            //   })
            //   if(!time) {
            //     this.tipContent = "还未到达晚休考勤时间";
            //     this.loading = false;
            //     return;
            //   }
            // }
          }
          this.api.getNightStudents(this.queried).then(res => {
            this.loading = false;
            if(res.Code==0) {
              var atSetting = atRes.Data||[];
              this.atSetting = atSetting;
              //------------------------------
              // res.Data = [
              //   { Addr: "A", Floors: [
              //       { Floor: "3", Dormitorys: [
              //         { DormitoryId: 1, Number: "333", Classes: "310+314+315+316", Students: [
              //           { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //           { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 7, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 8, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 9, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 10, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 11, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         ]},
              //         { DormitoryId: 2, Number: "333", Classes: "01", Students: [
              //           { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //           { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         ]},
              //         { DormitoryId: 3, Number: "333", Classes: "01", Students: [
              //           { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //           { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         ]},
              //         { DormitoryId: 4, Number: "333", Classes: "01", Students: [
              //           { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //           { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         ]},
              //         { DormitoryId: 5, Number: "333", Classes: "01", Students: [
              //           { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //           { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         ]},
              //         { DormitoryId: 6, Number: "333", Classes: "01", Students: [
              //           { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //           { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         ]},
              //         { DormitoryId: 7, Number: "333", Classes: "01", Students: [
              //           { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //           { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         ]},
              //         { DormitoryId: 8, Number: "333", Classes: "01", Students: [
              //           { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //           { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         ]},
              //         { DormitoryId: 9, Number: "333", Classes: "01", Students: [
              //           { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //           { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         ]},
              //         { DormitoryId: 10, Number: "333", Classes: "01", Students: [
              //           { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //           { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         ]},
              //         { DormitoryId: 11, Number: "333", Classes: "01", Students: [
              //           { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //           { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         ]},
              //         { DormitoryId: 12, Number: "333", Classes: "01", Students: [
              //           { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //           { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         ]},
              //         { DormitoryId: 13, Number: "333", Classes: "01", Students: [
              //           { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //           { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         ]},
              //         { DormitoryId: 14, Number: "333", Classes: "01", Students: [
              //           { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //           { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         ]},
              //         { DormitoryId: 15, Number: "333", Classes: "01", Students: [
              //           { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //           { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //           { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         ]},
              //       ]},
              //       { Floor: "3", Dormitorys: [
              //         { DormitoryId: 1, Number: "333", Classes: "01", Students: [
              //           { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //           { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //           // { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //           // { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //           // { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //           // { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         ]},
              //         // { DormitoryId: 2, Number: "333", Classes: "01", Students: [
              //         //   { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //         //   { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         // ]},
              //         // { DormitoryId: 3, Number: "333", Classes: "01", Students: [
              //         //   { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //         //   { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         // ]},
              //         // { DormitoryId: 4, Number: "333", Classes: "01", Students: [
              //         //   { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //         //   { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         // ]},
              //         // { DormitoryId: 5, Number: "333", Classes: "01", Students: [
              //         //   { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //         //   { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         // ]},
              //         // { DormitoryId: 6, Number: "333", Classes: "01", Students: [
              //         //   { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //         //   { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         // ]},
              //         // { DormitoryId: 7, Number: "333", Classes: "01", Students: [
              //         //   { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //         //   { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         // ]},
              //         // { DormitoryId: 8, Number: "333", Classes: "01", Students: [
              //         //   { StudentId: 1, AttendanceDtsId: 0, Face: false, FullName: "张三", GradeSn: "1", GradeId: 1, Status: 1 },
              //         //   { StudentId: 2, AttendanceDtsId: 0, FullName: "李四一", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 3, AttendanceDtsId: 0, FullName: "李四二", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 4, AttendanceDtsId: 0, FullName: "李四三", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 5, AttendanceDtsId: 0, FullName: "李四四", GradeSn: "1", GradeId: 1, Status: 2 },
              //         //   { StudentId: 6, AttendanceDtsId: 0, FullName: "李四五", GradeSn: "1", GradeId: 1, Status: 2 },
              //         // ]}
              //       ]}
              //     ]
              //   }
              // ];
              //------------------------------
              res.Data.forEach((e,index) => {
                e.Floors.forEach((n,index2) => {
                  if(index == 0 && index2 == 0) {
                    this.floorActive = n.Floor;
                  }
                  n.Dormitorys.forEach(m => {
                    m.showNames = true;
                    m.Students.forEach(p => {
                      p.show = false;
                      p.atMode = atSetting[p.GradeSn-1].NightAtMode;
                      if(p.atMode == 0) {
                        if(p.AttendanceDtsId==0 && p.Status!=4 && p.Status!=5 && !p.Face) {
                          var now = new Date();
                          if(now.getTime() > (new Date(atSetting[p.GradeSn-1].NightStartDateTime)).getTime()) {
                            p.noRecord = true;
                          }
                        }
                      } else if(p.atMode == 1) {
                        if((p.AttendanceDtsId==0 && p.Status==4 || p.Status==5) || p.Face) {
                          this.send.push({
                            Status: p.Status,
                            AttendanceId: p.AttendanceId,
                            AttendanceDtsId: p.AttendanceDtsId,
                            StudentId: p.StudentId,
                            ClassId: p.ClassId,
                            IsLeave: p.IsLeave,
                            LeaveType: p.LeaveType,
                            LeaveId: p.LeaveId,
                            LeaveDtsId: p.LeaveDtsId,
                            IsMedical: p.IsMedical,
                          })
                        }
                        this.stData.push(p);
                      }
                    })
                  })
                })
                this.mainData.push(e);
              })
              if(this.mainData.length) {
                this.showData = this.mainData[0].Floors;
              }
              console.log("main",this.mainData)
              //------------------------------
            }
          });
        } else {
          this.loading = false;
        }
      })
    },
    // statusChange(st,type) {
    //   st.show = false;
    //   st.Status = type;
    //   st.isChange = true;
    //   var obj = this.pickData.find(x => x.StudentId == st.StudentId);
    //   if(obj) {
    //     obj.Status = type;
    //   } else {
    //     this.pickData.push(st);
    //   }
    // },
    statusChange(st) {
      st.show = false;
      // st.Status = type;
      if(st.Status >= 3) {
        st.Status = 1;
      } else {
        st.Status = st.Status + 1;
      }
      st.isChange = true;
      var obj = this.pickData.find(x => x.StudentId == st.StudentId);
      if(obj) {
        obj.Status = st.Status;
      } else {
        this.pickData.push(st);
      }
    },
    getWeek(get=false) {
      if(this.params.AttendanceDate) {
        var weekDay = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
        var myDate = new Date(Date.parse(this.params.AttendanceDate));
        this.day = weekDay[myDate.getDay()];
        if(get===true) {
          this.getNightSt();
        }
      } else {
        this.day = "";
      }
    },
    addrChange(index) {
      if(this.active == index) return;
      this.active = index;
      this.showData = this.mainData[index].Floors;
    },
    addrChange2(item,index) {
      if(this.active == index) return;
      this.active = index;
      this.showData = this.mainData[index].Floors;
      if(item.Floors.length) {
        this.floorActive = item.Floors[0].Floor;
      }
      console.log(item)
    },
    save() {
      this.loading = true;
      // this.atApi.getListByDate(this.params.AttendanceDate).then(res => {
      //   if(res.Code==0) {
      var range = [];
      this.atSetting.forEach(e => {
        range.push({
          start: e.NightRollCallStartDateTime,
          end: e.NightRollCallEndDateTime,
          Grade: "高" + (e.GradeId==1?"一":(e.GradeId==2?"二":"三")),
          md: e.NightRollCallStartDateTime.split("-")[1] + "-" + e.NightRollCallStartDateTime.split("-")[2],
          md2: e.NightRollCallEndDateTime.split("-")[1] + "-" + e.NightRollCallEndDateTime.split("-")[2],
        })
      });
      var isTime = false;
      var now = this.TestTime?(new Date(this.params.AttendanceDate+' '+this.TestTime)):(new Date())
      for (let i = 0; i < range.length; i++) {
        const p = range[i];
        var s = new Date(p.start);
        var e = new Date(p.end);
        if(now.getTime() >= s.getTime() && now.getTime() <= e.getTime()) {
          isTime = true;
          break;
        }
      }
      if(!isTime) {
        this.tip(range,1);
        return;
      }
      
      var sub = this.pickData.concat([]);
      this.stData.forEach(e => {
        if(e.AttendanceDtsId == 0) {
          sub.push(e);
        }
      })
      for (let i = 0; i < sub.length; i++) {
        const p = sub[i];
        var s = new Date(range[p.GradeSn-1].start);
        var e = new Date(range[p.GradeSn-1].end);
        if(now.getTime() < s.getTime() || now.getTime() > e.getTime()) {
          this.tip(range,2);
          return;
        }
      }
      var arr = [];
      this.pickData.forEach(p => {
        arr.push({
          Status: p.Status,
          AttendanceId: p.AttendanceId,
          AttendanceDtsId: p.AttendanceDtsId,
          StudentId: p.StudentId,
          ClassId: p.ClassId,
          IsLeave: p.IsLeave,
          LeaveType: p.LeaveType,
          LeaveId: p.LeaveId,
          LeaveDtsId: p.LeaveDtsId,
          IsMedical: p.IsMedical,
        })
      });
      this.subData.Details = this.send.concat(arr);
      this.stData.forEach(e => {
        if(e.AttendanceDtsId == 0) {
          var obj = this.subData.Details.find(x => x.StudentId==e.StudentId);
          if(!obj) {
            this.subData.Details.push({
              Status: e.Status,
              AttendanceId: e.AttendanceId,
              AttendanceDtsId: e.AttendanceDtsId,
              StudentId: e.StudentId,
              ClassId: e.ClassId,
              IsLeave: e.IsLeave,
              LeaveType: e.LeaveType,
              LeaveId: e.LeaveId,
              LeaveDtsId: e.LeaveDtsId,
              IsMedical: e.IsMedical,
            })
          }
        }
      })
      this.subData.AttendanceDate = this.params.AttendanceDate;
      // this.loading = false;
      // console.log(this.subData)
      // return
      this.api.nightRollCall(this.subData).then(res => {
        this.loading = false;
        if(res.Code==0) {
          this.$message.success("提交成功");
          this.getNightSt();
        } else {
          this.$message.error(res.Msg);
        }
      })
      //   }
      // })
    },
    tip(range,type) {
      this.loading = false;
      this.$notify.error({
        title: type==1?'当前非手动考勤时间，不能提交':'存在非手动考勤时间的年级，请刷新重试',
        dangerouslyUseHTMLString: true,
        message: range[0].Grade + "：" + range[0].md + " ~ " + range[0].md2 + "</br>" +
                  range[1].Grade + "：" + range[1].md + " ~ " + range[1].md2 + "</br>" + 
                  range[2].Grade + "：" + range[2].md + " ~ " + range[2].md2,
        duration: 8000,
      });
    },
    onExport() {
      this.bnLoading = true;
      this.api.exportNightStudents(this.queried).then(() => {
        this.bnLoading = false;
      }).catch(() => {
        this.bnLoading = false;
      })
    },
    showStatic() {
      this.$refs.staticDialog.openDetails({ AttendanceDate: this.params.AttendanceDate });
    },
    showAttst() {
      this.$refs.attstDialog.openDetails({ AttendanceDate: this.params.AttendanceDate });
    },
  }
}
</script>

<style lang="scss" scoped>
.active {
  color: #fff;
  background: #409EFF;
}
.query {
  display:inline-block;
  margin-right: 30px;
  @media screen and (max-width: 767px) {
    width: calc(50% - 5px);
    margin-right: 5px;
    .el-input {
      width: calc(100% - 46px) !important;
    }
    label {
      display: inline-block;
      width: 36px;
      margin-bottom: 15px;
    }
  }
}

.query2 {
  display: inline-block;
  margin-right: 10px;
}

.normal {
  color: #000;
  background-color: #000;
}

//异常
.absent {
  color: red;
  background-color: red;
}

// 迟到
.late {
  color: orange;
  background-color: orange;
}

//请假
.leave {
  color: #999;
}
//有记录正常
.checkNormal {
  color: #2a2;
  background-color: #2a2;
}
//刷脸
// .face {
//   color: #55e;
// }

//无故缺勤
.free {
  color: #950c0c;
  background-color: #950c0c;
}

// .freeBn {
//   background-color:#950c0c;
//   border-color:#950c0c;
//   &:hover {
//     background-color: rgba(149,12,12,0.7);
//     border-color: rgba(149,12,12,0.7);
//   }
// }

.statusText {
  font-size: 14px;
  margin-right: 10px;
  display: inline-block;
  font-weight: bold;
  @media screen and (max-width: 767px) {
    margin-right: 4px;
  }
}
.statusText.nobold {
  font-weight: normal;
}
.isNull {
  text-align: center;
  letter-spacing: 8px;
  font-size: 20px !important;
  color: #aaa;
  padding: 16% 5% 0 0 !important;
  @media screen and (max-width: 767px) {
    padding: 45% 0 0 0 !important;
  }
}

.border {
  position: relative;
  margin: 15px 0;
  padding: 15px 0 0;
  font-size: 14px;
  height: calc(100vh - 225px);
  overflow: hidden;
  @media screen and (max-width: 767px) {
    height: calc(100vh - 270px);
  }
  @media screen and (min-width: 768px) {
    min-width: 1300px;
  }
}

.footer {
  text-align: right;
  white-space: nowrap;
  float: right;
  @media screen and (min-width: 768px) {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  @media screen and (max-width: 365px) {
    margin-right: -4px;
  }
  .footer-tip {
    @media screen and (min-width: 768px) {
      line-height: 32px;
    }
    @media screen and (max-width: 767px) {
      width: fit-content;
      display: inline-block;
    }
  }
}

.checkinge-query {
   .el-col{
    min-width: 190px;
  }
  label {
    margin-right: 10px;
    font-weight: 500;
  }

  /deep/ .el-date-picker,
  .el-select,
  .el-input {
    width: 140px;
  }
}

.tab-group {
  margin-bottom: 12px;
    @media screen and (min-width: 768px) {
      .tab-item:first-child {
        border: none;
      }
    }

  .tab-item {
    padding: 10px 0px;
    text-align: center;
    border: 1px solid #ddd;
    // border-right: none;
    cursor: pointer;
    @media screen and (max-width: 767px) {
      padding: 2px 0;
    }
  }

  // .tab-item:last-child {
  //   border-right: 1px solid #ddd;
  // }
}

.table {
    height: calc(100% - 53px);
    overflow: auto;
    padding-bottom: 15px;
    @media screen and (max-width: 767px) {
      height: calc(100% - 100px);
    }
  .table-item {
    display: flex;
    // align-items: center;
    text-align: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    @media screen and (max-width: 767px) {
      margin-bottom: 0;
      padding: 0 8px;
      align-items: flex-start;
    }
    .table-col {
      border: 1px solid #ddd;
      // border-right: none;
      @media screen and (min-width: 768px) {
        border-color: #666;
      }
      .el-col {
        padding: 5px 0;
      }
    }

    // .table-col:last-child {
    //   border-right: 1px solid #666;
    // }

    .table-tower {
      border: none !important;
      // line-height: 205px;
      position: relative;
      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .table-dormList_header {
      background-color: #ddd;
      padding: 0 8px;
    }
    .table-dormList{
      // height: 205px;
      overflow: hidden;
      @media screen and (max-width: 767px) {
        border-color: #333;
      }
    }
  }

  .table-item:last-child {
    .table-col {
      border-bottom: 1px solid #666;
    }
  }

  .student-list {
    // height: 176px;
    overflow: auto;
    .student-item { 
      .stName {
        font-size: 14px;
        cursor: pointer;
        width: 42px;
        display: inline-block;
        text-align: left;
        white-space: nowrap;
      }
    }
  }

  .dormDiv {
    width: 80%;
    overflow-x: auto;
    text-align: left;
    white-space: nowrap;
    .table-dormList {
      width: 50vw;
      display: inline-block;
      border: 1px solid #ddd;
      .student-item {
        text-align: center;
      }
    }
  }
}

.tab-tower-name {
  width: 16.667%;
  display: inline-block;
  border: none !important;
}
.tab-tower-box {
  white-space: nowrap;
  overflow: auto hidden;
  display: inline-block;
  vertical-align: bottom;
  width: 100%;
  padding: 0 8px;
  .tab-tower {
    display: inline-block;
    width: 65px;
  }
}

.floor-box {
  margin-bottom: 10px;
  width: calc(100% - 8px);
  margin-left: 8px;
  padding: 0 8px 0 0;
  white-space: nowrap;
  overflow: auto hidden;
  display: inline-block;
  border-left: 1px solid #ddd;
  .floor-item {
    width: 65px;
    height: 41px;
    text-align: center;
    line-height: 41px;
    border: 1px solid #ddd;
    border-left: none;
    display: inline-block;
    @media screen and (max-width: 767px) {
      height: 25px;
      line-height: 24px;
    }
  }
}

.floor-title {
  width: 16.667%;
  height: 41px;
  line-height: 41px;
  display: inline-block;
  text-align: center;
  vertical-align: top;
}
.hideNames {
  height: 30px !important;
}
.deepColor {
  border-color: #333 !important;
  .table-dormList_header {
  background-color: #aaa !important;
  }
}
.test_box {
  position: absolute;
  z-index: 999;
  padding: 5px;
  top: 0;
  right: 0;
}
.test_box1 {
  width: 339px;
  background-color: #ffffff;
  border: 1px solid #959595;
}

.isChange {
  color: #fff;
}
.nobg {
  background: none;
}
.hand-icon {
  width: 16px;
  height: 16px;
  vertical-align: -3px;
  margin-right:2px;
}
.face-icon {
  width: 16px;
  height: 16px;
  vertical-align: -3px;
  margin-right:2px;
}
.br {
  border-right: 1px solid #666 !important;
}
</style>